import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus, Search } from "lucide-react";
import { adminApi } from "@/lib/adminApi";
import { PageHead, StatusLabel, money } from "@/studio/ui";

export default function Projects() {
  const [statuses, setStatuses] = useState([]);
  const [status, setStatus] = useState("");
  const [q, setQ] = useState("");
  const [rows, setRows] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { adminApi.get("/studio/meta").then((r) => setStatuses(r.data.statuses)); }, []);
  useEffect(() => {
    const t = setTimeout(() => {
      adminApi.get("/studio/projects", { params: { q, ...(status ? { status } : {}) } }).then((r) => setRows(r.data));
    }, 250);
    return () => clearTimeout(t);
  }, [q, status]);

  return (
    <div className="st-page" data-testid="studio-projects-page">
      <PageHead eyebrow="Projects" title="All projects" lead="Every project, its rooms and its design fee.">
        <Link to="/admin/studio/projects/new" className="st-btn" data-testid="projects-new-button"><Plus size={15} /> New Project</Link>
      </PageHead>
      <div className="st-toolbar">
        <div className="st-search">
          <Search size={15} />
          <input className="st-input" placeholder="Search projects or clients" value={q} onChange={(e) => setQ(e.target.value)} data-testid="projects-search-input" />
        </div>
      </div>
      <div className="st-chips" style={{ marginBottom: 22 }} data-testid="projects-status-filter">
        {["", ...statuses].map((s) => (
          <button key={s || "all"} className={`st-chip ${status === s ? "is-on" : ""}`} onClick={() => setStatus(s)}
            data-testid={`projects-filter-${(s || "all").toLowerCase().replace(/\s+/g, "-")}`}>{s || "All"}</button>
        ))}
      </div>
      {!rows ? <p className="st-muted">Loading…</p> : rows.length === 0 ? <p className="st-empty" data-testid="projects-empty">No projects match.</p> : (
        <table className="st-table" data-testid="projects-table">
          <thead><tr><th>Project</th><th>Client</th><th className="st-num">Rooms</th><th className="st-num">Design fee</th><th>Status</th></tr></thead>
          <tbody>
            {rows.map((p) => (
              <tr key={p.id} onClick={() => navigate(`/admin/studio/projects/${p.id}`)} data-testid={`project-row-${p.id}`}>
                <td style={{ fontWeight: 600 }}>{p.name}{p.is_draft && <span className="st-tag" style={{ marginLeft: 8 }}>Draft · resume</span>}</td>
                <td data-label="Client">{p.client_name}</td>
                <td data-label="Rooms" className="st-num">{p.rooms_count}</td>
                <td data-label="Design fee" className="st-num" data-testid={`project-row-total-${p.id}`}>{p.pending ? <span className="st-tag st-tag--warn">Pending</span> : money(p.total)}</td>
                <td data-label="Status"><StatusLabel status={p.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
